import { render, staticRenderFns } from "./outStock.vue?vue&type=template&id=bc2ced10&scoped=true&"
import script from "./outStock.vue?vue&type=script&lang=js&"
export * from "./outStock.vue?vue&type=script&lang=js&"
import style0 from "./outStock.vue?vue&type=style&index=0&id=bc2ced10&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2ced10",
  null
  
)

export default component.exports